/*
 * Contest Module
 *
 * @author: Chiran Doshi
 */
/* global define, require */

define('Contests',[
    'jquery',
    'UI',
    'History',
    'Config',
    'Validation',
    'Auth',
    'Toastr',
    'Helper'
], function($, UI, History, Config, Validation, Auth, Toastr, Helper) {
	'use strict';
	var langs = Config.get('lang'),
		objImageForm = {},
		months = ['January','February','March','April','May','June','July','August','September','October','November','December'],

		 _addDatePicker = function(input) {

            input.Zebra_DatePicker({
                onClear: function() {
                    var base = $(this);
                    base.attr('data-value','');
                },
                onSelect: function(ev) {

                    var base = $(this),
                        dob = base.val(),
                        temp,year,month,day;

                    if(dob) {
                        base.attr('data-value',dob);
                        temp = Date.parse(dob);
                        if(!isNaN(temp)) {
                            temp = new Date(dob);
                            year = temp.getFullYear();
                            month = temp.getMonth() + 1;
                            day = temp.getDate();
                            dob = day + ' ' + months[month - 1] + ', ' + year;
                        }
                    }

                    base.val(dob);
                }
            });
        },


		_bindEvents = function() {

      if(Config.get('page.route') == 'blog.interest') {
        require(['DatePicker'], function(DatePicker) {
           _addDatePicker($('.dob:input'));
        });
      }

			// When user click on participate now button
			UI.$b.on('click', '.open-contest-form', function() {

				$('.contest-detail-parent').addClass('noscroll');

				if(Config.get('page.route') == 'blog.interest') {
					console.log('blogger');
				}
				else if(Helper.Url.getParam('guid')) {
					console.log('cool');
				}
				else if (!Auth.checkLoginRequired({source: 'contest'})) {
					return false;
				}

				$('.popup-action-menu').css('display','block');
				History.pushState({
	                popupId: 'popup-action-menu',
	                url: window.location.href,
	                removeEl: false,
	                callback: function() {
	                	$('.contest-detail-parent').removeClass('noscroll');
	                }
	            });
			});

			// when user click on close form
			UI.$b.on('click','#contestFormContainer .popup-close', function(ev) {
				History.popState();
			});

			// When user submits their contest entry
			UI.$b.on('submit', '#bloggerForm', function() {
				var $form = $(this),
					formData = $.extend($form.serializeArray(), {}),
					_fd = new FormData();

				$.each(formData, function(i, input) {
                    _fd.append(input.name, input.value);
                });


				if(Helper.Url.getParam('guid')) {
                	_fd.append('guid',Helper.Url.getParam('guid'));
                }

                if(Helper.Url.getParam('access_token')) {
                	_fd.append('access_token',Helper.Url.getParam('access_token'));
                }


                _fd.append('date_of_birth',$('.dob').attr('data-value'));


                $form.find(':submit').addClass('loading');

                $.ajax({
                	url: '/ajax/apply/blogger',
                	data: _fd,
                  type:'POST',
                	processData: false,
                  contentType: false,
                	success: function(response) {
                		var toastr;

	                    $form.find(':submit').removeClass('loading');

	                    if (response.status) {

	                    	$form[0].reset();

	                        toastr = new Toastr({
	                            'message': response.message
	                        });

	                    } else {
	                        toastr = new Toastr({
	                            'message': response.message,
	                            'class': 'toastr-error',
	                            'icon': 'ion-alert'
	                        });
	                    }
                	}
                });



				return false;
			});

			// When user submits their contest entry
			UI.$b.on('submit', '#contestForm', function() {

	            var $form = $(this),
	            images = objImageForm ? objImageForm.getImages() : null,
	            contestValidationRules = {
					first_name: {
						length: {
							minimum: 1,
		                    tooShort: '^' + langs.err_name
						}
					},
					last_name: {
						length: {
							minimum: 1,
			                tooShort: '^' + langs.err_name
		            	}
					},
					email: {
						length: {
							minimum: 1
		            	},
		                email: {
		                    message: '^' + langs.err_email_invalid
		                }
		            },
		            caption: {
		            	length: {
							minimum: 1
		            	}
		            }
				},

	        	validation = new Validation({
	                form: $form,
	                allConstraints: contestValidationRules
	        	}),

	        	formData = $.extend($form.serializeArray(), {}),

	        	 _fd = new FormData();

	        	 // If form values invalid return
	        	if (validation.isValid() !== true) {
                    return false;
                }

                $form.find(':submit').addClass('loading');

                $.each(images, function(i, file) {
                    _fd.append('image' + i, file);
                });

                $.each(formData, function(i, input) {
                    _fd.append(input.name, input.value);
                });

                if(Helper.Url.getParam('guid')) {
                	_fd.append('guid',Helper.Url.getParam('guid'));
                }

                if(Helper.Url.getParam('access_token')) {
                	_fd.append('access_token',Helper.Url.getParam('access_token'));
                }


                $.ajax({
                	url:'/ajax/applycontest',
                	data:_fd,
                	type:'POST',
                	processData: false,
                    contentType: false,
                	success: function(response) {
                    var toastr;

                    $form.find(':submit').removeClass('loading');

                    if (response.status) {

                    	$('.open-contest-form').addClass('hidden');

                    	$form[0].reset();

                        History.popState();

                        toastr = new Toastr({
                            'message': response.message
                        });

                    } else {
                        toastr = new Toastr({
                            'message': response.message,
                            'class': 'toastr-error',
                            'icon': 'ion-alert'
                        });
                    }
                    }
                });

				return false;
			});
		},
		init = function() {
		    require(['ImageForm'], function (ImageForm) {
	            objImageForm = new ImageForm({
	                elForm: '#contestFormContainer',
	                elFileSelect: '#postFileSelect',
	                elPreviewContainer: '#postAttachments',
	                elSelectTrigger: '#btnUploadImage',
	                maxImages: 1,
	                onChange: function() {
	                	console.log('changed');
	                }
	            });
	        });

			_bindEvents();
		};

	return {
		init:init
	}
});

